const processInclude = require('sfraScripts/util');

$(document).ready(function() {
	processInclude(require('./components/mtoQuickview'));
});

require('./components/spinner');
